<template>
  <MainLayout>
    <div 
      :class="theme === 'dark' ? 'tw-bg-[#151515] tw-text-gray-100' : 'tw-bg-gray-100 tw-text-gray-800'" 
      class="tw-min-h-screen tw-p-4 md:tw-p-8"
      :data-theme="theme"
    >
      <div class="tw-max-w-6xl tw-mx-auto">
        
        <!-- Header -->
        <div class="tw-mb-8">
          <div class="tw-flex tw-items-center tw-gap-3 tw-mb-1">
            <h1 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-2xl tw-font-black">
              Minha Conta
            </h1>
            <span class="tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-blue-500/10 tw-text-blue-500 tw-text-[9px] tw-font-black tw-uppercase tw-tracking-widest tw-border tw-border-blue-500/20">
              {{ user.tipo_usuario }}
            </span>
            <span v-if="user.status === 'ativo'" class="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-green-500/10 tw-text-green-500 tw-text-[9px] tw-font-black tw-uppercase tw-tracking-widest">
              <span class="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-green-500"></span>
              Ativo
            </span>
          </div>
          <p class="tw-text-xs tw-font-medium tw-opacity-50">
            ID: #{{ user.id }} • Membro desde {{ formatarData(user.created_at) }}
          </p>
        </div>

        <!-- Alerta de Feedback -->
        <div>
          <div v-if="successAlert" class="tw-mb-6 tw-flex tw-items-center tw-gap-3 tw-bg-green-500/10 tw-border tw-border-green-500/20 tw-p-4 tw-rounded-xl">
            <i class="fa-solid fa-circle-check tw-text-green-500"></i>
            <span class="tw-text-sm tw-font-bold tw-text-green-500">{{ successAlert }}</span>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-8">
          
          <div class="lg:tw-col-span-2 tw-space-y-8">
            <!-- Card: Dados Pessoais -->
            <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-p-6 md:tw-p-8 tw-shadow-2xl">
              <div class="tw-flex tw-items-center tw-gap-4 tw-mb-8">
                <div :class="theme === 'dark' ? 'tw-bg-blue-500/10' : 'tw-bg-blue-50'" class="tw-p-3 tw-rounded-xl">
                  <i class="fa-solid fa-address-card tw-text-blue-500 tw-text-xl"></i>
                </div>
                <h2 class="tw-text-lg tw-font-bold">Dados Pessoais</h2>
              </div>

              <form @submit.prevent="salvar(1)" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                <div class="tw-space-y-2">
                  <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Nome</label>
                  <input :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-gray-300' : 'tw-bg-gray-100 tw-text-black'" type="text" v-model="name" class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" :disabled="isLoading">
                </div>
                <div class="tw-space-y-2">
                  <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Sobrenome</label>
                  <input :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-gray-300' : 'tw-bg-gray-100 tw-text-black'" type="text" v-model="lastname" class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" :disabled="isLoading">
                </div>
                <div class="tw-space-y-2">
                  <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Login</label>
                  <input :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-gray-300' : 'tw-bg-gray-100 tw-text-black'" type="text" v-model="login" class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" :disabled="isLoading">
                </div>
                <div class="tw-space-y-2">
                  <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">E-mail</label>
                  <input :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-gray-300' : 'tw-bg-gray-100 tw-text-black'" type="email" v-model="email" class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" :disabled="isLoading">
                  <p v-if="apiErrors.email" class="tw-text-[10px] tw-text-red-500 tw-font-bold tw-mt-1">{{ apiErrors.email[0] }}</p>
                </div>

                <div class="md:tw-col-span-2 tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-pt-4 tw-gap-4 tw-border-t tw-border-gray-800/5">
                  <p v-if="errors.dadosPessoais" class="tw-text-xs tw-font-bold tw-text-red-500">{{ errors.dadosPessoais }}</p>
                  <div class="tw-flex tw-gap-3 tw-w-full md:tw-w-auto">
                    <button :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'" class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl" type="button" @click="cancelar(1)" :disabled="isLoading">
                      Descartar
                    </button>
                    <button type="submit" :disabled="isLoading" class="tw-flex-1 md:tw-flex-none tw-px-8 tw-py-2.5 tw-rounded-xl tw-bg-green-600 tw-text-white tw-text-sm tw-font-bold hover:tw-bg-green-700 tw-shadow-lg tw-shadow-green-600/20 tw-border-none">
                      <span v-if="isLoading"><i class="fa-solid fa-circle-notch tw-animate-spin tw-mr-2"></i>Salvando...</span>
                      <span v-else>Salvar Alterações</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <!-- Card: Segurança -->
            <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-p-6 md:tw-p-8 tw-shadow-2xl">
              <div class="tw-flex tw-items-center tw-gap-4 tw-mb-8">
                <div :class="theme === 'dark' ? 'tw-bg-orange-500/10' : 'tw-bg-orange-50'" class="tw-p-3 tw-rounded-xl">
                  <i class="fa-solid fa-shield-halved tw-text-orange-500 tw-text-xl"></i>
                </div>
                <h2 class="tw-text-lg tw-font-bold">Privacidade e Segurança</h2>
              </div>

              <form @submit.prevent="salvar(3)" class="tw-space-y-6">
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6">
                  <!-- Senha Atual -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Senha Atual</label>
                    <div class="tw-relative">
                      <input 
                        :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-gray-300' : 'tw-bg-gray-100 tw-text-black'" 
                        :type="showPass['atual'] ? 'text' : 'password'" 
                        v-model="atualSenha" 
                        class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" 
                        :disabled="isLoading">
                      <button type="button" @click="showPass['atual'] = !showPass['atual']" class="tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-500 hover:tw-text-green-500 tw-bg-transparent tw-border-none">
                        <i :class="showPass['atual'] ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                      </button>
                    </div>
                    <p v-if="apiErrors.senhaAtual" class="tw-text-[9px] tw-text-red-500 tw-font-bold tw-mt-1">{{ apiErrors.senhaAtual[0] }}</p>
                  </div>
                  <!-- Nova Senha -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Nova Senha</label>
                    <div class="tw-relative">
                      <input 
                      :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-gray-300' : 'tw-bg-gray-100 tw-text-black'" 
                      :type="showPass['nova'] ? 'text' : 'password'" 
                      v-model="novaSenha" 
                      class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" 
                      :disabled="isLoading">
                      <button type="button" @click="showPass['nova'] = !showPass['nova']" class="tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-500 hover:tw-text-green-500 tw-bg-transparent tw-border-none">
                        <i :class="showPass['nova'] ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                      </button>
                    </div>
                    <p v-if="apiErrors.novaSenha" class="tw-text-[9px] tw-text-red-500 tw-font-bold tw-mt-1">{{ apiErrors.novaSenha[0] }}</p>
                  </div>
                  <!-- Confirmar Senha -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Confirmar Senha</label>
                    <div class="tw-relative">
                      <input 
                        :class="[
                            !senhasCoincidem && confirmNovaSenha ? 'tw-ring-1 tw-ring-red-500' : '',
                            theme === 'dark'
                                ? 'tw-bg-slate-800 tw-text-gray-300'
                                : 'tw-bg-gray-100 tw-text-black'
]"                        :type="showPass['confirm'] ? 'text' : 'password'" 
                        v-model="confirmNovaSenha" 
                        class="tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none" 
                        :disabled="isLoading"
                      >
                      <button type="button" @click="showPass['confirm'] = !showPass['confirm']" class="tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-500 hover:tw-text-green-500 tw-bg-transparent tw-border-none">
                        <i :class="showPass['confirm'] ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                      </button>
                    </div>
                    <p v-if="!senhasCoincidem && confirmNovaSenha" class="tw-text-[9px] tw-text-red-500 tw-font-bold tw-uppercase tw-mt-1">As senhas não coincidem</p>
                  </div>
                </div>

                <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-pt-4 tw-gap-4 tw-border-t tw-border-gray-800/5">
                  <p v-if="errors.senha" class="tw-text-xs tw-font-bold tw-text-red-500">{{ errors.senha }}</p>
                  <button 
                    type="submit" 
                    :disabled="isLoading || (!senhasCoincidem && novaSenha)"
                    :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'" 
                    class="tw-w-full md:tw-w-auto tw-px-8 tw-py-2.5 tw-rounded-xl tw-text-sm tw-font-bold tw-border-none disabled:tw-opacity-50"
                  >
                    {{ isLoading ? 'Processando...' : 'Atualizar Senha' }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Unidades -->
          <div class="lg:tw-col-span-1">
            <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-p-6 tw-shadow-2xl tw-sticky tw-top-[89px]">
              <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                <i class="fa-solid fa-building tw-text-green-500"></i>
                <h2 class="tw-text-sm tw-font-bold tw-uppercase tw-tracking-wider">Unidades</h2>
              </div>
              <div class="tw-space-y-3 tw-max-h-[37.5rem] tw-overflow-y-auto custom-scrollbar">
                <div 
                  v-for="unid in unidades" 
                  :key="unid.id" 
                  :class="theme === 'dark' ? 'tw-bg-black/20' : 'tw-bg-white'" 
                  class="tw-flex tw-items-center tw-gap-4 tw-p-4 tw-rounded-xl hover:tw-shadow-md"
                >
                  <div class="tw-w-12 tw-h-12 tw-rounded-lg tw-overflow-hidden tw-bg-gray-200 tw-flex-none">
                    <img 
                      v-if="unid.logo" 
                      :src="getImageUrl(unid.logo)" 
                      class="tw-w-full tw-h-full tw-object-cover"
                      :alt="unid.nome"
                    />
                    <div v-else class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-gray-800">
                      <i class="fa-solid fa-building tw-text-gray-600"></i>
                    </div>
                  </div>

                  <div class="tw-flex-1 tw-min-w-0">
                    <p :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-sm tw-font-black tw-truncate tw-leading-tight tw-uppercase">
                      {{ unid.nome }}
                    </p>
                    <p class="tw-text-[10px] tw-font-bold tw-opacity-40 tw-uppercase tw-tracking-wider">
                      {{ unid.cidade }} - {{ unid.estado }}
                    </p>
                  </div>

                  <router-link 
                    :to="'/v2/unidades/' + unid.id" 
                    class="tw-text-gray-400 hover:tw-text-green-500"
                  >
                    <i class="fa-solid fa-chevron-right tw-text-xs"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
/* eslint-disable */
import MainLayout from "@/components/layouts/v2/MainLayout.vue";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import axios from 'axios';

export default {
    name: "UserSettings",
    components: { MainLayout },
    setup() {
        const store = useStore();
        const user = computed(() => store.getters['auth/getUser']);
        const theme = computed(() => store.getters['ui/theme']);
        const unidades = computed(() => store.state.unidades.unidades || []);

        const isLoading = ref(false);
        const successAlert = ref('');
        const errors = ref({ dadosPessoais: '', senha: '' });
        const apiErrors = ref({}); // Laravel validation mapping

        const showPass = ref({ atual: false, nova: false, confirm: false });

        const name = ref(user.value?.nome || '');
        const lastname = ref(user.value?.sobrenome || '');
        const login = ref(user.value?.usuario || '');
        const email = ref(user.value?.email || '');

        const atualSenha = ref('');
        const novaSenha = ref('');
        const confirmNovaSenha = ref('');

        const senhasCoincidem = computed(() => novaSenha.value === confirmNovaSenha.value);

        onMounted(async () => {
            if (unidades.value.length === 0) {
                try { await store.dispatch("unidades/fetchUnidades"); } catch (e) {}
            }
        });

        async function salvar(secao) {
            isLoading.value = true;
            errors.value = { dadosPessoais: '', senha: '' };
            apiErrors.value = {};
            successAlert.value = '';

            try {
                if (secao === 1) {
                    const payload = { "nome": name.value, "sobrenome": lastname.value, "email": email.value, "usuario": login.value };
                    await axios.put(`/usuario/update/${user.value.id}`, payload);
                    store.commit('auth/setUser', { ...user.value, ...payload });
                    successAlert.value = "Perfil atualizado com sucesso!";
                } else {
                    const payload = { "senhaAtual": atualSenha.value, "novaSenha": novaSenha.value, "novaSenha_confirmation": confirmNovaSenha.value };
                    const response = await axios.put(`/usuario/update/${user.value.id}/password`, payload);
                    
                    if (response.data.status === 'success') {
                        successAlert.value = response.data.message;
                        atualSenha.value = ''; novaSenha.value = ''; confirmNovaSenha.value = '';
                    }
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (e) {
                if (e.response?.data?.errors) {
                    apiErrors.value = e.response.data.errors;
                }
                // Fallback para a mensagem de erro principal do seu JSON
                if (e.response?.data?.message) {
                    errors.value[secao === 1 ? 'dadosPessoais' : 'senha'] = e.response.data.message;
                }
            } finally {
                isLoading.value = false;
            }
        }

        function cancelar(secao) {
            if (secao === 1) {
                name.value = user.value?.nome || ''; lastname.value = user.value?.sobrenome || '';
                login.value = user.value?.usuario || ''; email.value = user.value?.email || '';
            } else {
                atualSenha.value = ''; novaSenha.value = ''; confirmNovaSenha.value = '';
            }
            apiErrors.value = {}; errors.value = { dadosPessoais: '', senha: '' }; successAlert.value = '';
        }

        const formatarData = (data) => {
            if (!data) return '';
            return new Date(data).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
        };

        const getImageUrl = (path) => {
          return path ? `${process.env.VUE_APP_SERVER}/storage/${path}` : '';
        };

        return {
            user, theme, unidades, name, lastname, login, email,
            atualSenha, novaSenha, confirmNovaSenha, isLoading,
            errors, apiErrors, successAlert, salvar, cancelar, formatarData,
            showPass, senhasCoincidem, getImageUrl
        };
    }
};
</script>